/**
 * Display the lumber schedule details returned by the Lumber Schedule Lookup
 * query that is stored in dynamicInputResult field of the request
 * @param {Local.LumberScheduleLookupProps} props
 */
export const LumberScheduleLookup = ({ result }) => {
  if (!result?.scheduleNumber) return null;
  const { scheduleNumber, aQty, aItem, location, finalFamily, panSize } = result;
  return (
    <span data-testid='dynamic-input-result'>
      {`<${scheduleNumber}> ${aQty} pcs of ${aItem} at ${location} -- Final Family: ${finalFamily} -- Full Pan = ${panSize}`}
    </span>
  );
};
